import Phaser from "phaser";
import images from "../assets/*.png";

const gameState = {
    numCoordinates: {},
}

let speed = 300;

class Kitchen extends Phaser.Scene {
    preload() {
        this.load.image('kitchen', images.kitchen)
        this.load.image('boy', images.boy)
    }

    create() {
        this.add.image(480, 320, 'kitchen')

        gameState.player = this.physics.add.sprite(150, 600, 'boy').setScale(0.4)
        this.physics.world.setBounds(0, 0, 960, 640)
        gameState.player.setCollideWorldBounds(true)
        gameState.player.body.collideWorldBounds = true
    }

    update() {

        const cursors = this.input.keyboard.createCursorKeys();

        const rightArrow = cursors.right.isDown;
        const leftArrow = cursors.left.isDown;
        const upArrow = cursors.up.isDown;
        const downArrow = cursors.down.isDown;

        if (rightArrow) {
            movePlayerRight();
        } else if (leftArrow) {
            movePlayerLeft();
        } else if (upArrow) {
            movePlayerUp();
        } else if (downArrow) {
            movePlayerDown();
        } else {
            stopPlayer()
        }
        const playerXCoord = gameState.player.x;
        const playerYCoord = gameState.player.y;

        function movePlayerRight() {
            gameState.player.flipX = false;
            gameState.player.setTexture('boy');
            gameState.player.setVelocityX(speed);
            gameState.player.setVelocityY(0);
        }
      
        function movePlayerLeft() {
            gameState.player.flipX = true;
            gameState.player.setTexture('boy');
            gameState.player.setVelocityX(-speed);
            gameState.player.setVelocityY(0);
        }
      
        function movePlayerUp() {
            gameState.player.flipX = false;
            gameState.player.setTexture('boy');
            gameState.player.setVelocityX(0);
            gameState.player.setVelocityY(-speed);
        }
      
        function movePlayerDown() {
            gameState.player.flipX = false;
            gameState.player.setTexture('boy');
            gameState.player.setVelocityX(0);
            gameState.player.setVelocityY(speed);
        }

        function stopPlayer() {
            gameState.player.flipX = false
            gameState.player.setTexture('boy')
            gameState.player.setVelocityX(0)
            gameState.player.setVelocityY(0)
        }
    
    }
}

export default Kitchen